import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { FeedDb } from 'lib/cosmos/feed/feedDb.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

type ExtendedFeed = FeedDb.IFeedItem & {
	readonly originUser?: UserDb.IUserItem;
	readonly fromNow: string;
};

@Component({
	selector: 'mod-my-notifications',
	templateUrl: './my-notifications.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class MyNotificationsComponent extends TypeCoreComponent<UserDb.IUserItem> implements OnInit {
	public readonly myFeeds = signal<readonly ExtendedFeed[] | undefined>(undefined);

	constructor() {
		super();

		this.sharedDataInit = (sharedData) => {
			this.initFeeds();

			if (sharedData.data) {
				this.markAllFeedsAsRead(sharedData.data);
			}
		};
	}

	private initFeeds(): void {
		super.subscribeToObservable(
			this.dependencies.httpService
				.get<readonly FeedDb.IFeedItem[]>((builder) => builder.withCustomApiRoute('feed', 'myFeeds').build())
				.pipe(
					map((response) => {
						this.myFeeds.set(
							response.data.map<ExtendedFeed>((m) => {
								return {
									...m,
									fromNow: super.fromNow(m.system.created),
									originUser: super.getOptionalItem<UserDb.IUserItem>(
										m.originUserId,
										response.linkedItems ?? []
									)
								};
							})
						);
					})
				)
		);
	}

	private markAllFeedsAsRead(user: UserDb.IUserItem): void {
		this.dependencies.layoutService.markAllFeedsAsRead(user.id);
	}
}
